import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Queuelogo from '../assets/images/favicon.png'
import gtwakqueuelogo from '../assets/images/gtawk.png'
import { LoginUserinfo } from '../redux/action/login';
import '../assets/css/campaignpage.css'
import Comtemplete from './comtemplete';

function Queuepage() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  let payload = {};
  const [queuevalue, setQueuevalue] = useState("");
  const [queuename, setQueuenames] = useState([]);
  
  const que_agentname = localStorage.getItem("username")
  
  const config_data = JSON.parse(localStorage.getItem("config"))
  
  let queue_value = config_data.projects[0].queue
  const tenant_code = config_data.projects[0].tenant_code
  let config_user = config_data.projects[0].userInfo[0].user_email
  const station = config_data.projects[0].userInfo[0].user_phone_number
  
    payload['agent_id'] = tenant_code
    payload['avatar_url'] = ""
    payload['campaign'] = "doocti"
    payload['station'] = station
    payload['user'] = config_user
    payload['queue'] = queuevalue
    console.log("queuepayload======>",payload);    

  
  
  useEffect(() => {
    const extractedQueueNames = queue_value.map(queue => queue.name);
    setQueuenames(extractedQueueNames);
   
  }, []);


  const handleQueuevalue = (event) => {
    const selectedStatus = event.target.value;
    setQueuevalue(selectedStatus);
    localStorage.setItem('queuelogin',true)
    dispatch(LoginUserinfo(payload)) 
   

    console.log("Click queue value==========>", queuevalue);

  };
  const handlecampaginvalue1 = (event) => {
    const selectedStatus = event.target.value;
    setQueuevalue(selectedStatus);

  };

  return (

<div>
        <Comtemplete>
        <img className="campaign-logo" src={ !JSON.parse(localStorage.getItem('config')).projects[0].config[0].white_lable?Queuelogo:JSON.parse(localStorage.getItem('config')).projects[0].config[0].avatar} />

          <div className='cam-placeholdertext'> {"Select Queue"}</div>
          <div className='cam-selectbox'>

            <select
              id="dispositionStatus"
              value={queuevalue}
              onChange={handlecampaginvalue1}
              className="cam-selectinlinestyle"

            >
              <option value="">Select Queues</option>
              {queuename.map((option, index) => (
                <option key={index} value={option}>
                  {option}
                </option>
              ))}
            </select>

          </div>
          {/* {queuevalue !== "" && ( // Display button only if queuevalue is not empty
          <button type="button" className="cam-button" onClick={handleQueuevalue}>
            Proceed
          </button>
        )} */}
             <button type="button" className="cam-button" onClick={handleQueuevalue}>
            Proceed
          </button>


        </Comtemplete>
      </div>


  

  )
}
export default Queuepage;
